import { Component, OnDestroy, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';
import { Pipeline } from 'app/modules/projects/projects.types';
import { AccountService } from 'app/core';
import { Account } from 'app/core/models/account.types';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { Task } from '../tasks.types';
import { LegacyTasksTabService } from '../services/tasks.service';

@Component({
  selector: 'tasks-crm-panel',
  templateUrl: './tasks-crm-panel.component.html',
  styleUrls: ['./tasks-crm-panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TasksCrmPanelComponent extends OnDestroyMixin implements OnInit, OnDestroy {
  pipelines: Pipeline[];
  account: Account;
  _tasks: Task[];
  private _unsubscribeAll: Subject<void>;
  get tasks() {
    return this._tasks;
  }
  @Input() set tasks(values: any) {
    if (values) {
      this._tasks = values;
    }
  }
  @Output() openTaskDetails: EventEmitter<Task> = new EventEmitter<Task>();

  constructor(private _accountService: AccountService,
      private readonly tasksService: LegacyTasksTabService) {
    super();
    this._accountService.currentAccount.pipe(untilComponentDestroyed(this)).subscribe((accountData) => {
      this.account = accountData;
    });
    this._unsubscribeAll = new Subject();
  }
  ngOnInit(): void {}

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
    super.ngOnDestroy();
  }

  trackByFn(index: number, item: any): any {
    return item.id || index;
  }

  getTaskStatus(status) {
    if (!status) {
      return;
    }
    return this.tasksService.workflowStatuses.find((taskStatus) => taskStatus.key === status);
  }

  openTask(task) {
    this.openTaskDetails.emit(task);
  }
}
